import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';
import { AuthService, Container } from '../../../../symphony';
import {
	getRecomendedCourseInfo,
	SlDiscussContext,
} from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './RecommendedCourses.scss';

export function RecommendedCourses(): JSX.Element {
	useStyles(s);
	const isLoggedIn = Container.take('global', AuthService).isLoggedIn();

	if (isLoggedIn) {
		return null;
	}

	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const onSeeAllCoursesClick = () => {
		actions$.next({
			type: ActionType.OnSeeAllCoursesClick,
			requestType: RequestType.Parallel,
		});
	};

	const onRecommendedCourseClick = (alias: string) => {
		actions$.next({
			type: ActionType.OnRecommendedCourseClick,
			requestType: RequestType.Parallel,
			data: {
				alias,
			},
		});
	};

	return (
		<div className="discuss-recommended-courses">
			<div className="discuss-recommended-courses__header">
				<h3 className="discuss-recommended-courses__title">
					{getRecomendedCourseInfo().TITLE}
				</h3>
				<p className="discuss-recommended-courses__sub-title">
					{getRecomendedCourseInfo().SUB_TITLE}
				</p>
			</div>
			<ul className="discuss-recommended-courses__list">
				{getRecomendedCourseInfo().TOP_COURSES.map(
					({
						alias, title, desc, imageSource,
					}) => (
						<li key={alias}>
							<LocalizedLink
								className="discuss-recommended-courses__item"
								to={`/learn/courses/${alias}`}
								title={title}
								target="_blank"
								onClick={() => onRecommendedCourseClick(alias)}
							>
								<img
									src={imageSource}
									alt=""
									className="discuss-recommended-courses__item-image"
								/>
								<div className="discuss-recommended-courses__item-info">
									<p className="discuss-recommended-courses__item-title">
										{title}
									</p>
									<p className="discuss-recommended-courses__item-desc">
										{desc}
									</p>
								</div>
							</LocalizedLink>
						</li>
					),
				)}
			</ul>

			<div className="discuss-recommended-courses__footer">
				<Button
					buttonType="secondary"
					asChild
					size="s"
					onClick={onSeeAllCoursesClick}
				>
					<LocalizedLink to={getRecomendedCourseInfo().CTA.LINK}>
						{getRecomendedCourseInfo().CTA.TEXT}
					</LocalizedLink>
				</Button>
			</div>
		</div>
	);
}
